import { Grid2 as Grid } from "@mui/material";
import NormalText from "../Typography/NormalText";
import TextFieldCustom from "../TextFieldCustom/TextFieldCustom";
import Select from "../select/Select";

const AnalysisLine = ({ isEn, isEditMode, elementKey, element, onChange }) => {
  const handleChange = (quantity) => {
    onChange(elementKey, { ...element, quantity });
  };

  const handleUnitChange = (unit) => {
    onChange(elementKey, { ...element, quantityUnit: unit });
  };

  return (
    <Grid container spacing={2}>
      <Grid item size={{ xs: 3, md: 2 }}>
        <NormalText sx={{ fontWeight: 500 }}>{element.symbol} </NormalText>
      </Grid>
      <Grid item size={{ xs: 0, md: 4 }}>
        <NormalText>{isEn ? element.nameEn : element.nameGr}</NormalText>
      </Grid>
      <Grid item size={{ xs: 3, md: 2 }}>
        {isEditMode ? (
          <TextFieldCustom value={element.quantity} onChange={handleChange} />
        ) : (
          <NormalText>{element.quantity}</NormalText>
        )}
      </Grid>
      <Grid item size={{ xs: 3, md: 2 }}>
        {isEditMode ? (
          <Select
            value={element.quantityUnit}
            options={element.quantityUnits.map((unit) => ({
              value: unit,
              label: unit,
            }))}
            onChange={handleUnitChange}
          />
        ) : (
          <NormalText>{element.quantity}</NormalText>
        )}
      </Grid>
    </Grid>
  );
};

export default AnalysisLine;
